import { computed } from "vue";
import { useRoute } from "vue-router";

export function useRouteAccess() {
  const route = useRoute();
  
  const shouldShowUpgradePrompt = computed(() => {
    return route.meta.requiresUpgrade === true;
  });
  
  return {
    shouldShowUpgradePrompt
  };
}
